import { LitElement, html } from "lit-element";

class ToneTransport extends LitElement {
  static get properties() {
    return {
      minTempo: { type: Number },
      maxTempo: { type: Number },
      rampSpeed: { type: Number },
    };
  }

  constructor() {
    super();

    this.minTempo = 100;
    this.maxTempo = 200;
    this.rampSpeed = 4;
    this.isRampStart = true;
  }

  createRamp({ tempoHigh, tempoLow, delay }) {
    return () => {
      const tempo = this.isRampStart ? tempoHigh : tempoLow;
      Tone.Transport.bpm.rampTo(tempo, delay);
      this.isRampStart = !this.isRampStart;
    };
  }

  firstUpdated() {
    const startContainer = this.shadowRoot.querySelector("#start-container");
    const startButton = this.shadowRoot.querySelector("#start");

    startButton.addEventListener("click", async () => {
      const ramp = this.createRamp({
        tempoHigh: this.maxTempo,
        tempoLow: this.minTempo,
        delay: this.rampSpeed,
      });

      Tone.Transport.bpm.value = this.minTempo;
      await Tone.start();
      await Tone.Transport.start();
      setInterval(
        (function doRamp() {
          ramp();
          return doRamp;
        })(),
        this.rampSpeed * 1000
      );

      startContainer.removeChild(startButton);
    });
  }

  render() {
    return html`
      <style>
        #start {
          z-index: 100;
          font-size: 30px;
          width: 150px;
          height: 75px;
        }

        #start-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
        }
      </style>
      <div id="start-container">
        <button id="start">start</button>
      </div>
      <slot></slot>
    `;
  }
}
customElements.define("tone-transport", ToneTransport);
